import { conclusionErrorStatus } from "data/conclusions/statuses"
import { localize } from "locale"

export const formatConclusionStatus = status =>
  status === conclusionErrorStatus ? localize("error") : status
